/**
 * 鉴权状态 (Zustand)
 * - 持久化到 localStorage
 * - 401/403 自动清空
 */

import { create } from 'zustand';
import { setUnauthorizedHandler } from '../api/client';

interface AuthState {
  token: string | null;
  deviceId: string | null;
  deviceName: string | null;
  setAuth: (token: string, deviceId: string, deviceName: string) => void;
  clear: () => void;
}

const STORAGE_KEYS = ['device_token', 'device_id', 'device_name'] as const;

function readInitial(): Pick<AuthState, 'token' | 'deviceId' | 'deviceName'> {
  return {
    token: localStorage.getItem('device_token'),
    deviceId: localStorage.getItem('device_id'),
    deviceName: localStorage.getItem('device_name'),
  };
}

export const useAuthStore = create<AuthState>((set) => {
  const initial = readInitial();

  // 注册 401/403 自动清空
  setUnauthorizedHandler(() => {
    useAuthStore.getState().clear();
    // 跳转交给路由层 useEffect 监听 token 变化
  });

  return {
    ...initial,
    setAuth: (token, deviceId, deviceName) => {
      localStorage.setItem('device_token', token);
      localStorage.setItem('device_id', deviceId);
      localStorage.setItem('device_name', deviceName);
      set({ token, deviceId, deviceName });
    },
    clear: () => {
      for (const k of STORAGE_KEYS) localStorage.removeItem(k);
      set({ token: null, deviceId: null, deviceName: null });
    },
  };
});